import { SupplierResponseInterface } from '../../../../../shared/interfaces/survey.interface';
import { Snapshot } from '../../../../shared/interfaces/snapshot';

export class SupplierSnapshot implements Snapshot<SupplierResponseInterface> {
  public cpi!: number;
  public scpi?: number;

  constructor(private _supplier: SupplierResponseInterface) {
    this.take();
  }

  get(): SupplierResponseInterface {
    return this._supplier;
  }

  update(supplier: SupplierResponseInterface): void {
    if (this.equal(supplier)) {
      this._supplier = supplier;
    }
  }

  restore(): void {
    this._supplier.cpi = this.cpi;
    this._supplier.scpi = this.scpi;
  }

  take(): void {
    this.cpi = this._supplier.cpi;
    this.scpi = this._supplier.scpi;
  }

  exists(): boolean {
    return true;
  }

  equal(other: SupplierResponseInterface): boolean {
    return this._supplier.suppliers[0].id === other.suppliers[0].id;
  }
}
